import { ShoppingBagIcon } from 'lucide-react';
import { routes } from '../data/site';
import { SiteLink } from './SiteLink';
export function ShopOnlineBand() {
  return <section aria-labelledby="shop-online-heading" className="w-full border-y border-ink/10 bg-white" data-id="element-463" data-mp="rbrfc7igj8n5">
      <div className="mx-auto flex max-w-container flex-col gap-4 px-5 py-6 sm:px-8 lg:flex-row lg:items-center lg:justify-between lg:gap-10 lg:py-7" data-id="element-464" data-mp="mhwomk4fptek">
        <div className="min-w-0" data-id="element-465" data-mp="cn4tdmybrimy">
          <p className="text-[13px] font-bold uppercase text-pegasus-blue" data-id="element-466" data-mp="cjz1y12844o2">Shop Pegasus Online</p>
          <h2 id="shop-online-heading" className="mt-1 text-[24px] font-semibold leading-8 text-ink" data-id="element-467" data-mp="7p39x0wzlhay">
            Shop Spa &amp; Pool Supplies Online
          </h2>
          <p className="mt-1 max-w-2xl text-[16px] leading-6 text-ink/75" data-id="element-468" data-mp="3uszwep5d24gt">
            Shop our filters, water care and maintenance products with convenient online ordering.
          </p>
        </div>

        <SiteLink to={routes.supplies} className="inline-flex min-h-[48px] shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-btn bg-pegasus-blue px-6 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-ink" data-id="element-469" data-mp="1t1mtg5mye6ne">
          <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-470" data-mp="3cmf5hk7z7sef" />
          Shop Online
        </SiteLink>
      </div>
    </section>;
}